import Vue from "vue";
import VueRouter from "vue-router";
import companyIntro from "../views/companyIntro.vue";
import homePage from "../views/homePage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: companyIntro,
    meta: {
      keepAlive: true,
    },
  },
  // companyIntro 已作为首页，/intro 重定向到首页，兼容旧链接
  {
    path: "/intro",
    redirect: "/",
  },
  // 分类项目里页，从首页产品类型卡片进入
  {
    path: "/projects/:slug",
    name: "projects",
    component: homePage,
  },
];

const router = new VueRouter({
  // history 模式需要服务器配置 fallback,否则直接访问子路由会 404
  mode: "history",
  routes,
});

export default router;
